export default theme => ({
  secondaryColumn: {
    [theme.breakpoints.down('lg')]: {
      display: 'none',
    },
  },
});
